export enum OfferCompleteStatus {
    Incomplete = 'COMPLETE_STATUS_INCOMPLETE',
    Complete = 'COMPLETE_STATUS_COMPLETE',
    Divergent = 'COMPLETE_STATUS_DIVERGENT',
}
